import React from 'react';
import {
  EMentoringField,
  EScheduleStatus,
  EMentoringClassStatus,
  EFeedbackScore,
} from 'enums/mentoring.enum';

export const CScheduleStatus = {
  [EScheduleStatus.Available]: '예약가능',
  [EScheduleStatus.UnAvailable]: '',
  [EScheduleStatus.Pending]: '예약대기',
  [EScheduleStatus.Reserved]: '예약마감',
};

export const CNumOfSlice = 3;
export const CNumOfOneHourSlice = 2;

export const CMentoringClassStatusTag = {
  [EMentoringClassStatus.CanceledByMentor]: 'gray-tag',
  [EMentoringClassStatus.CanceledByMentee]: 'gray-tag',
  [EMentoringClassStatus.RequestPending]: 'red-tag',
  [EMentoringClassStatus.RequestRejected]: 'gray-tag',
  [EMentoringClassStatus.RequestAccepted]: '',
  [EMentoringClassStatus.Completed]: 'gray-tag',
  [EMentoringClassStatus.TimeLimit]: 'gray-tag',
};

export const CMentoringClassStatusValue = {
  [EMentoringClassStatus.CanceledByMentor]: '멘토링 취소',
  [EMentoringClassStatus.CanceledByMentee]: '멘토링 취소',
  [EMentoringClassStatus.RequestPending]: '수락 대기중',
  [EMentoringClassStatus.RequestRejected]: '수락 거절',
  [EMentoringClassStatus.RequestAccepted]: '',
  [EMentoringClassStatus.Completed]: '지난 멘토링',
  [EMentoringClassStatus.TimeLimit]: '멘토링 취소',
};

//페이지별 title지정을 위해
export const CMentoringFieldKoreanType: { [key: string]: string } = {
  [EMentoringField.Consulting]: '컨설팅',
  [EMentoringField.Finance]: '금융',
  [EMentoringField.Tech]: '테크',
};

export const CMentoringFieldType: { [key: string]: string } = {
  [EMentoringField.Consulting]: 'Consulting',
  [EMentoringField.Finance]: 'Finance',
  [EMentoringField.Tech]: 'Tech',
};

export const CFeedbackScore = {
  [EFeedbackScore.Excellent]: 'Excellent',
  [EFeedbackScore.Good]: 'Good',
  [EFeedbackScore.Average]: 'Average',
  [EFeedbackScore.NeedImprovement]: 'Need Improvement',
  [EFeedbackScore.Bad]: 'Bad',
  [EFeedbackScore.NotApplicable]: 'N/A',
};

export const CPlanPrice = [
  /* backend의 PLAN_PRICE랑 동일하게 맞춰주기 */
  /* Junior */
  {
    price: 150000,
  },
  /* Senior */
  {
    price: 250000,
  },
];

export type TcompanyColor = {
  'McKinsey & Company': string;
  BCG: string;
  'Bain & Company': string;
};

export const companyColor: TcompanyColor = {
  'McKinsey & Company': '#1267E9',
  BCG: '#3CAC40',
  'Bain & Company': '#D81F26',
};

export const feedbackType: { [key: string]: string } = {
  overall: 'Overall',
  impact: 'Impact',
  problemsolving: 'Problem Solving',
  communication: 'Communication',
};
